import React from 'react';

const CreateAppt=() => {
    return(
        <div className='schedule'>
            <h1 className='scheduleTitle'>Schedule an Appointment</h1>
            <h2 className='scheduleInfo'>Text us at 801-602-8356 to schedule a consultation with Raili</h2>
            <p className='scheduleInfoBreak'>- or -</p>
            <h3 className='scheduleInfoEmail'>Send us an email at railicustombridal@gmail.com</h3>
            <p className='notice'>**At Raili Custom Bridal, every gown is handcrafted and tailored through an individualized design process. To ensure the highest level of craftsmanship and attention to detail, we require a minimum of <span className='noticeSpan'>four</span> months' notice for all orders. Requests for a shorter turnaround time may incur a Rush Order Fee.**</p>
        </div>
    );
}

export default CreateAppt;